<div class="text-center" *ngIf="!isReady">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<div class="row" *ngIf="isReady">
    <div class="col-sm-12" *ngIf="!isCartPage">
        <h5 class="text-muted d-flex justify-content-between align-items-center mb-4 mt-6">
            <strong><span>Choose your Pick-up Location</span></strong>
        </h5>
    </div>

    <form [formGroup]="locationsForm" class="col-sm-12">
        <div class="row">
            <div 
                *ngFor="let store of storeLocations; index as i"
                [ngClass]="{ 
                    'col-sm-6 mb-3': !isCartPage, 
                    'col-sm-12': isCartPage, 
                    'cart-pickup-margin': isCartPage,
                    'cart-pickup-padding border-bottom': isCartPage && i != storeLocations.length - 1 
                }"
            >
                <div [ngClass]="{'card z-depth-1': !isCartPage}">
                    <div [ngClass]="{'card-body': !isCartPage}">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <strong>{{store.LocationName}}</strong><br/>
                                <small
                                    *ngIf="stockMap.get(store.LocationCode)?.allInStock" 
                                    class="badge green" 
                                    style="color: white;" 
                                    attr.data-testid="in-stock-badge-{{store.LocationCode | lowercase}}"
                                >
                                    In Stock at Store
                                </small>
                                
                                <small
                                    *ngIf="stockMap.get(store.LocationCode)?.partiallyInStock"
                                    style="color: white;"
                                    class="badge orange hand"
                                    triggers="hover"
                                    placement="top"
                                    container="body"
                                    mdbPopoverHeader="Partial Store Transfer Required"
                                    mdbPopover="Not all items in your order are at this store. Please allow a few days for an internal stock transfer."
                                    attr.data-testid="partial-transfer-badge-{{store.LocationCode | lowercase}}"
                                > 
                                    Partial Store Transfer Required <i class="fas fa-info-circle"></i>
                                </small>

                                <small
                                    *ngIf="stockMap.get(store.LocationCode)?.allOutOfStock"
                                    style="color: white;"
                                    class="badge orange hand"
                                    triggers="hover"
                                    placement="top"
                                    container="body"
                                    mdbPopoverHeader="Store Transfer Required"
                                    mdbPopover="All item(s) in your order are not at this store. Please allow a few days for an internal stock transfer."
                                    attr.data-testid="full-transfer-badge-{{store.LocationCode | lowercase}}"
                                > 
                                    Store Transfer Required <i class="fas fa-info-circle"></i>
                                </small>
                            </div>
                            <div>
                                <input 
                                    class="form-check-input"
                                    type="radio"
                                    formControlName="pickupLocation"
                                    [value]="store.LocationCode"
                                    [id]="store.LocationCode"
                                    [attr.disabled]="shippingDetails.ConsistsEntirelyOfDigitalItems ? 'disabled' : null"
                                />
                                <label [for]="store.LocationCode" class="m-0" attr.data-testid="store-location-{{store.LocationCode | lowercase}}">
                                    <small>In Store</small>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 p-3" *ngIf="!isCartPage">
                <small> To avoid delays, please wait for an email telling you that your order is ready.
                    <a href="#" (click)="showModal($event)" class="magnific-ajax" target="_blank">
                        More info
                    </a>
                </small>
            </div>
        </div>
    </form>
</div>

<div 
    mdbModal 
    #instructionsModal="mdbModal" 
    class="modal fade" 
    tabindex="-10" 
    role="dialog" 
    aria-hidden="true"
    [config]="modalConfig" 
    data-testid="pickup-instructions-modal"
>
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button 
                    type="button" 
                    class="close pull-right align-middle" 
                    aria-label="Close"
                    (click)="instructionsModal.hide()" 
                    data-testid="pickup-instructions-close-modal-button"
                >
                    <span aria-hidden="true">×</span>
                </button>
                <h3 class="modal-title w-100" id="myModalLabel">Buy Online, Pick up In Store Instructions</h3>
            </div>
            <div class="modal-body">
                <div class="row instructions">
                    <div class="col">


                        <strong>Select your product</strong>

                        <p>
                            Please note the stocking status on the product page, if it is not in stock, it will not
                            be available for immediate pick up.
                        </p>

                        <strong>Select your location</strong>

                        <p>
                            During Checkout Select the pick up tab in the shopping cart and then pick the store of your
                            choice for pick up.
                        </p>

                        <strong>Complete your order</strong>

                        <p>
                            Once you complete your order you will receive an order confirmation email.
                            Once your order is ready for pick up, we will notify you.
                            <span class="text-danger">You must show valid ID to pick up.</span>
                        </p>
                        <hr />

                        <p><strong>You placed your order, what is next?</strong></p>

                        <strong>1. Wait for the order ready email</strong>

                        <p>
                            Please note: Please don't head to the store until you receive your 'Ready for Pick up'
                            email.
                            Although we will strive to get your order ready as fast as possible,
                            we cant't guarantee orders for same day pick up that are placed after 3pm.
                        </p>

                        <p>
                            If your order is urgent, please call the store directly.
                        </p>

                        <p>
                            <span class="text-danger">*Saturday orders will not be processed until the following
                                business day*</span>
                        </p>

                        <strong>2. Got your email?</strong>

                        <p>
                            Grab your Photo ID & order email and head to the store for your gear!
                            You will need your order email (on your phone is fine) and valid Photo ID.
                        </p>

                        <strong>3. Once you get here</strong>

                        <p>
                            Simply head over to Reception/Customer Service and they will direct you to the pick-up area.
                        </p>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>